import { Injectable } from '@angular/core';
import { BaseError, Result } from './result.model';

@Injectable({
  providedIn: 'root'
})
export class ResultHelper {
  static isSuccess<T = void>(result: Result<T>): boolean {
    return result.isSuccess;
  }

  static isFailure<T = void>(result: Result<T>): boolean {
    return result.isFailure || !result.isSuccess;
  }

  static getValue<T>(result: Result<T>): T | null {
    if (this.isSuccess(result) && result.value !== undefined) {
      return result.value;
    }
    return null;
  }

  static getError<T = void>(result: Result<T>): BaseError | null {
    if (this.isFailure(result)) {
      return result.error;
    }
    return null;
  }

  // Helper pentru a verifica dacă un obiect este Result
  static isResult(obj: any): obj is Result<any> {
    return obj && 
           typeof obj === 'object' && 
           typeof obj.isSuccess === 'boolean' && 
           typeof obj.isFailure === 'boolean' &&
           obj.error !== undefined;
  }
}